import { Switch, Route, Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { InteractionStatus } from '@azure/msal-browser';
import { useAccount, useIsAuthenticated, useMsal } from '@azure/msal-react';
import PrivacyNotice from '../PrivacyNotice';
import CookiesPolicy from '../CookiesPolicy';
import TermsAndConditions from '../TermsAndConditions';
import Faqs from '../Faqs';
import Spinner from 'react-bootstrap/Spinner';
import RenderFooter from './molecules/RenderFooter';
import RenderHeader from './molecules/RenderHeader';
import SubscriberPortalConatiner from '../SubscriberDataFeed/organisms/template/SubscriberPortalConatiner';
import { deleteCookies, getCookies } from '../../../utils/LocalStorageManager';
import { cookiesConstants } from '../../../constants/Constants';
import { useEffect } from 'react';

function App() {
  const { inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = useAccount(accounts[0] || {});
  const userId = (account && account.localAccountId) || '';

  useEffect(() => {
    const beforeUnloadListener = () => {
      getCookies(cookiesConstants.ntisWebCookieKey) !=
        cookiesConstants.ntisAcceptWebCookieValue &&
        deleteCookies(`${cookiesConstants.ntisAddDataFeedCookieKey}-${userId}`);
    };
    window.addEventListener('beforeunload', beforeUnloadListener);
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  }, []);

  console.log('Public page ');
  scrollTo(0, 0);
  const renderMain = () => {
    return (
      <Row className="main">
        <Col className="px-0">
          <Switch>
            <Route
              exact
              path="/"
              render={() => <Redirect to="/subscriberportal" />}
            />
            <Route
              path="/subscriberportal"
              component={SubscriberPortalConatiner}
            />
            <Route path="/privacy-notice" component={PrivacyNotice} />
            <Route path="/cookies" component={CookiesPolicy} />
            <Route path="/faqs" component={Faqs} />
            <Route
              path="/terms-and-conditions"
              component={TermsAndConditions}
            />
            <Redirect
              to={{
                state: { error: true },
              }}
            />
          </Switch>
        </Col>
      </Row>
    );
  };

  if (
    isAuthenticated ||
    (inProgress !== InteractionStatus.Startup &&
      inProgress !== InteractionStatus.HandleRedirect)
  ) {
    return (
      <>
        <RenderHeader operatorHeaderText="" operatorMenuArray={null} />
        {renderMain()}
        <RenderFooter />
      </>
    );
  } else {
    return <Spinner className="loader" animation="border" role="status" />;
  }
}

export default App;
